import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const PauseIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9998 3.1665C13.3628 3.1665 10.7849 3.94849 8.59224 5.41358C6.39958 6.87866 4.69062 8.96104 3.68145 11.3974C2.67228 13.8337 2.40824 16.5146 2.92271 19.101C3.43718 21.6875 4.70705 24.0632 6.57175 25.9279C8.43645 27.7926 10.8122 29.0625 13.3986 29.577C15.9851 30.0914 18.6659 29.8274 21.1023 28.8182C23.5386 27.8091 25.621 26.1001 27.0861 23.9074C28.5512 21.7148 29.3332 19.1369 29.3332 16.4998C29.3332 14.7489 28.9883 13.0151 28.3182 11.3974C27.6482 9.77972 26.666 8.30986 25.4279 7.07175C24.1898 5.83363 22.72 4.85151 21.1023 4.18144C19.4846 3.51138 17.7508 3.1665 15.9998 3.1665ZM15.9998 27.1665C13.8902 27.1665 11.8279 26.5409 10.0738 25.3688C8.31964 24.1968 6.95246 22.5309 6.14513 20.5818C5.33779 18.6327 5.12656 16.488 5.53813 14.4189C5.94971 12.3497 6.96561 10.4491 8.45737 8.95736C9.94913 7.4656 11.8498 6.4497 13.9189 6.03813C15.988 5.62655 18.1327 5.83779 20.0818 6.64512C22.0309 7.45246 23.6968 8.81963 24.8689 10.5738C26.0409 12.3279 26.6665 14.3902 26.6665 16.4998C26.6665 19.3288 25.5427 22.0419 23.5423 24.0423C21.5419 26.0427 18.8288 27.1665 15.9998 27.1665Z"
        fill="currentColor"
      />
      <path
        d="M19.9998 11.1665C19.6462 11.1665 19.3071 11.307 19.057 11.557C18.807 11.8071 18.6665 12.1462 18.6665 12.4998V20.4998C18.6665 20.8535 18.807 21.1926 19.057 21.4426C19.3071 21.6927 19.6462 21.8332 19.9998 21.8332C20.3535 21.8332 20.6926 21.6927 20.9427 21.4426C21.1927 21.1926 21.3332 20.8535 21.3332 20.4998V12.4998C21.3332 12.1462 21.1927 11.8071 20.9427 11.557C20.6926 11.307 20.3535 11.1665 19.9998 11.1665Z"
        fill="currentColor"
      />
      <path
        d="M11.9998 11.1665C11.6462 11.1665 11.3071 11.307 11.057 11.557C10.807 11.8071 10.6665 12.1462 10.6665 12.4998V20.4998C10.6665 20.8535 10.807 21.1926 11.057 21.4426C11.3071 21.6927 11.6462 21.8332 11.9998 21.8332C12.3535 21.8332 12.6926 21.6927 12.9427 21.4426C13.1927 21.1926 13.3332 20.8535 13.3332 20.4998V12.4998C13.3332 12.1462 13.1927 11.8071 12.9427 11.557C12.6926 11.307 12.3535 11.1665 11.9998 11.1665Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default PauseIcon;
